import { render, staticRenderFns } from "./TimerRecorder.vue?vue&type=template&id=364d3e14&scoped=true"
import script from "./TimerRecorder.vue?vue&type=script&lang=ts"
export * from "./TimerRecorder.vue?vue&type=script&lang=ts"
import style0 from "./TimerRecorder.vue?vue&type=style&index=0&id=364d3e14&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364d3e14",
  null
  
)

export default component.exports